import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../auth/AdminAuthContext";

export default function RequireAdminAuth({
  children,
}: {
  children: React.ReactElement;
}) {
  const location = useLocation();
  const { loading, isAuthenticated } = useAdminAuth();

  if (loading) {
    return <div style={{ padding: 20 }}>Checking admin session...</div>;
  }
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search || ""}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return children;
}
